import { render, staticRenderFns } from "./BasicInfoCom.vue?vue&type=template&id=6bbb5144&scoped=true"
import script from "./BasicInfoCom.vue?vue&type=script&lang=js"
export * from "./BasicInfoCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb5144",
  null
  
)

export default component.exports